import type { JSX } from 'react';
import type { ComponentsMap } from '@frontend/formEngine/readForm/readForm.types';
import { ProcessActivityReadContext } from '@frontend/components/pages/episodeCategory/carePath/process/processActivity/processActivityRead/processActivityReadContext';
import { ReadForm } from '@frontend/formEngine/readForm/ReadForm';
import { useDefinedContext } from '@frontend/utils/hooks/useDefinedContext';
import { BariPostCaroInactivity } from '../BariPostCaroInactivity';

export function BariPostCaroInactivityPoliReportRead(): JSX.Element {
    const { processActivity } = useDefinedContext(ProcessActivityReadContext);

    return <ReadForm components={getComponents()} />;

    function getComponents(): ComponentsMap {
        const map: ComponentsMap = new Map();
        map.set(
            'inactiviteit',
            <BariPostCaroInactivity
                showReportCounts={true}
                untilProcessActivityId={processActivity.id}
            />
        );

        return map;
    }
}
